import React, { useState } from "react";
import MyCard from "../../tools/MyCard.jsx";
import { trackingData } from "../../../data/trackingData.jsx";
import Pagination from "../../util/Pagination.jsx";

export default function Devices() {
 const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

 

  const data=trackingData.tracking // Assume trackingData is available in the scope

  const total = data.length; // example
  const start = (page - 1) * limit;
  const end = Math.min(start + limit, total);
  const pageData = data.slice(start, end);

  return (
    <div className="space-y-2 max-h-fit pb-28"> {/* pb to avoid fixed footer overlap */}
      <div id="devices-main">{/* anchor for pagination alignment (avoid sidebar overlap) */}
      <MyCard
        className={"mt-4 pb-2 relative h-auto"}
        children={
          <>
            <div className="w-full overflow-auto max-h-[75vh] rounded"> {/* scrollable table area */}
              <table className="min-w-full border-collapse rounded-t-lg overflow-hidden">
              <thead>
                <tr className="border-t border-slate-300 dark:border-slate-700">
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                    UTM Source
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                    Click Type
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                    Device Id
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                    User Id
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                    App Version
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                    Model
                  </th>
                  <th className="sticky top-0 z-30 bg-slate-100 dark:bg-slate-800/60 text-start  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pl-4">
                    DateTime
                  </th>
                 
                </tr>
              </thead>
              <tbody>

               {pageData.map((item,index)=>(
                <tr key={item.device_id || index} className="bg-white dark:bg-slate-800/60 hover:bg-slate-400/20 hover:dark:bg-slate-900/10 border-t border-slate-300 dark:border-slate-700">
                  <td className="text-start  text-[10px] font-semibold font-sans text-slate-700 dark:text-slate-400 ps-4 py-4 ">
                    <div className="bg-gray-200/60 dark:bg-gray-100/6 rounded-xl w-fit px-[6px] py-[4px] flex items-center justify-center">
                    {item.utm_source}

                    </div>
                  </td>
                  <td className="text-start text-[10px] font-semibold font-sans text-green-900 dark:text-green-950 py-4">
                    <div className="bg-green-300/30 dark:bg-green-300/20 w-fit flex items-center justify-center px-2  py-[4px] rounded-2xl">

                    Organic
                    </div>
                  </td>
                  <td className="text-start text-xs text-slate-600 dark:text-slate-400 py-4">
                    {item.device_id}
                  </td>
                  <td className="text-start text-xs text-slate-600 dark:text-slate-400 py-4">
                   
                  
                    {item.uuid && (<>
                    <a href={`/apps/Mangocash/users/${item.uuid}`}   className="text-blue-600 hover:underline">
                      {item.uuid || "N/A"}
                    </a>
                    </>)}
                  </td>
                  <td className="text-start text-xs text-slate-600 dark:text-slate-400 py-4">
                    {'v'+item.app_version}
                  </td>
                  <td className="text-start flex flex-col text-xs text-slate-600 dark:text-slate-400 py-4">
                     <span className="font-semibold font-sans">{item.model}</span>
                     <span>{'v'+item.android_version}</span>
                      
                  </td>
                  <td className="text-start text-xs text-slate-600 dark:text-slate-400 py-4 pl-4">
                    {item.formatted_date}
                  </td>
                </tr>
               ))}
               
              </tbody>
            </table>
            </div>
          </>
        }
      />
      </div>
      
      <Pagination
        page={page}
        limit={limit}
        total={total}
        onPageChange={setPage}
        onLimitChange={(l) => {
          setLimit(l);
          setPage(1); // reset to first page
        }}
        fixed={true}
        constrainTo="#devices-main"
      />
    </div>
  );
}
